import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://oottan.com';
const DEFAULT_IMAGE = `${BASE_URL}/og-banner.png`;
const SITE_NAME = 'Oottan';

const SEO = ({ title, description, canonical, noindex = false, ogImage = DEFAULT_IMAGE }) => {
	const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - Your Trusted Platform for Perfect Match`;
	const canonicalUrl = canonical ? `${BASE_URL}${canonical}` : BASE_URL;

	return (
		<Helmet>
			<title>{fullTitle}</title>
			<meta name="description" content={description} />
			<link rel="canonical" href={canonicalUrl} />
			{noindex && <meta name="robots" content="noindex, nofollow" />}

			{/* Open Graph */}
			<meta property="og:title" content={fullTitle} />
			<meta property="og:description" content={description} />
			<meta property="og:url" content={canonicalUrl} />
			<meta property="og:image" content={ogImage} />
			<meta property="og:image:width" content="1200" />
			<meta property="og:image:height" content="630" />
			<meta property="og:type" content="website" />
			<meta property="og:site_name" content={SITE_NAME} />

			{/* Twitter */}
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={fullTitle} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:url" content={canonicalUrl} />
			<meta name="twitter:image" content={ogImage} />
		</Helmet>
	);
};

export default SEO;
